// src/utils/teamUtils.js

/**
 * Determines whether a team has all required fields to participate
 * in matching, posting scrimmages, or showing interest.
 *
 * Required:
 * - name
 * - ageGroup
 * - gender
 * - skillLevel
 * - location.lat
 * - location.lng
 */
export function isTeamMatchReady(team) {
  if (!team) return false;

  return Boolean(
    team.name &&
    team.ageGroup &&
    team.gender &&
    team.skillLevel &&
    team.location?.lat &&
    team.location?.lng
  );
}
